import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import { PAGE_CONTENT_CONTAINER_NAME } from 'bundles/unified-description-page-common/constants';

type BorderLHS = 'border' | 'border-left' | 'border-right' | 'border-top' | 'border-bottom';

const styles = {
  border: (lhs: BorderLHS) => {
    return `${lhs}: 1px solid var(--cds-color-neutral-stroke-primary-weak);`;
  },
};

/**
 * Container query that fires when the `page-content` container is narrower than
 * the md breakpoint — i.e., the two-panel chat panel has docked and narrowed
 * the XDP content column. Dormant outside the two-panel layout.
 */
export const NARROW_XDP_CONTAINER_QUERY = `@container ${PAGE_CONTENT_CONTAINER_NAME} (max-width: ${
  breakpoints.values.md - 1
}px)`;

/**
 * Container-query override that forces a Grid item (or any flex child) to fill
 * the chat-narrowed XDP content column.
 */
export const twoPanelGridItemFullWidth = css`
  ${NARROW_XDP_CONTAINER_QUERY} {
    && {
      max-width: 100%;
      flex-basis: 100%;
    }
  }
`;

/**
 * When list view is forced on `LearningProductCard` at md+ viewports (e.g.,
 * narrowed chat-docked column), its `leftAlignProductCardTags` style absolutely
 * positions the status tags over the preview image. Restore the natural-flow
 * placement (badge above image, as on mobile). Apply on a wrapper that contains
 * the forced-list-view cards.
 */
export const forcedListStatusTagOverride = css`
  .cds-ProductCard-listCard .cds-ProductCard-statusTags {
    position: static !important;
    max-width: 100% !important;
    padding-left: 0 !important;
  }
`;

export default styles;
